import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Flex, Link } from 'ui';
import styled from 'styled-components';
import { announcementsToShowOnFeed } from '../../../utils/app-configs';
import { isObjectNullOrEmpty } from '../../../utils/helpers';

const StyledFlex = styled(Flex)`
  font-size: initial;
  font-weight: normal;
  margin-left: 20px;
  gap: 5px;
`;

const AnnouncementsFeedTitle = ({
  intl,
  setIsSidepanelOpen,
}) => {
  const {
    isLoadingHomeAnnouncements,
    announcementsHomeTotalCount,
    announcementsFeedError,
  } = useSelector(state => state.announcements);

  const countToShow =
    announcementsHomeTotalCount > announcementsToShowOnFeed ?
      announcementsToShowOnFeed :
      announcementsHomeTotalCount;

  const isShowAllButtonVisible = announcementsHomeTotalCount > announcementsToShowOnFeed;

  const showAllAnnouncements = () => {
    if (setIsSidepanelOpen) {
      setIsSidepanelOpen(true);
    }
  };

  return (
    <Flex aib>
      {intl.formatMessage({ id: 'announcements.home.TITLE' })}
      {!isLoadingHomeAnnouncements &&
        isObjectNullOrEmpty(announcementsFeedError)
        && !!announcementsHomeTotalCount &&
        <StyledFlex aic>
          <span>
            {/* eslint-disable-next-line max-len */}
            {`${intl.formatMessage({ id: 'announcements.home.SHOWN' })} ${countToShow}/${announcementsHomeTotalCount}`}
          </span>
          {isShowAllButtonVisible && <>
            <span>|</span>
            <Link onClick={showAllAnnouncements}>
              {intl.formatMessage({ id: 'announcements.home.SHOW_ALL' })}
            </Link>
          </>
          }
        </StyledFlex>
      }
    </Flex>
  );
};

AnnouncementsFeedTitle.propTypes = {
  intl: PropTypes.object,
  setIsSidepanelOpen: PropTypes.func,
};

export default injectIntl(AnnouncementsFeedTitle);
